<template lang="pug">
#dashboard
  form(
    name="page-form"
    @submit.prevent="submit"
    novalidate
  )
    spinner(v-if="settings.loading")
    div(v-else)
      b-tabs(
        :animated="false"
        position="is-centered"
        @change="selectPage"
        expanded
      )
        b-tab-item(
          v-for="page in pages"
          :key="page.id"
          :label="page.title"
          :icon="page.icon"
        )
          section.section
            b-field(grouped)
              b-field(label="Heading" expanded)
                b-input(
                  v-model="page.h1"
                  @input="updateH1"
                )
              b-field(label="Sub-Heading" expanded)
                b-input(
                  v-model="page.h2"
                  @input="updateH2"
                )
            b-field(label="Page Body")
              markdown-editor(
                v-model="page.body"
                @input="updateBody"
              )
            //- div(v-if="page.key == 'home' && events.length > 0")
            //-   b-table(
            //-     :data="events"
            //-     :striped="true"
            //-     :checked-rows.sync="featuredEvents"
            //-     checkable
            //-   )
            //-     template(slot-scope="props")
            //-       b-table-column(label="Featured Events") {{ props.row.title }}
            button.button.is-success(
              :class="{ 'is-loading': settings.submitting }"
            ) Save Changes
</template>

<script>
import _ from 'lodash';
import { mapGetters } from 'vuex';
import MarkdownEditor from '@/components/form/MarkdownEditor';
import Spinner from '@/components/Spinner';
import * as actions from '@/store/types/actions';
import * as getters from '@/store/types/getters';
import * as mutations from '@/store/types/mutations';

export default {
  name: 'dashboard',
  components: {
    MarkdownEditor,
    Spinner,
  },
  computed: {
    ...mapGetters({
      page: getters.GET_PAGE,
      events: getters.GET_EVENTS,
    }),
  },
  created() {
    this.settings.loading = true;
    this.$store.dispatch(actions.DO_GET_PAGES, { per: 0 })
      .then((pages) => {
        this.pages = _.cloneDeep(pages);
        setTimeout(() => {
          this.settings.loading = false;
        }, 250);
      });
    this.$store.dispatch(actions.DO_GET_EVENTS, { per: 0, event_status: 'current' })
      .then(() => {
        this.featuredEvents = _.filter(this.events, e => e.is_featured);
      });
  },
  data() {
    return {
      featuredEvents: [],
      pages: [],
      settings: {
        submitting: false,
        loading: false,
      },
    };
  },
  methods: {
    selectPage(index) {
      const page = _.cloneDeep(this.pages[index]);
      this.$store.commit(mutations.SET_PAGE, page);
    },
    submit() {
      this.settings.submitting = true;
      const payload = {
        id: this.page.id,
        h1: this.page.h1,
        h2: this.page.h2,
        body: this.page.body,
      };
      if (this.page.key === 'home') {
        this.events.forEach((event) => {
          this.$store.dispatch(actions.DO_UPDATE_EVENT_FIELD, {
            id: event.id,
            is_featured: _.find(this.featuredEvents, e => e.id === event.id) !== undefined,
          });
        });
      }
      this.$store.dispatch(actions.DO_UPDATE_PAGE, payload)
        .then((response) => {
          this.settings.submitting = false;
          this.$store.commit(mutations.SET_APP_SNACKBAR, {
            type: 'is-success',
            message: response.message,
          });
        });
    },
    updateH1(val) {
      this.$store.commit(mutations.SET_PAGE_FIELD, { h1: val });
    },
    updateH2(val) {
      this.$store.commit(mutations.SET_PAGE_FIELD, { h2: val });
    },
    updateBody(val) {
      this.$store.commit(mutations.SET_PAGE_FIELD, { body: val });
    },
  },
};
</script>

<style lang="scss">
#dashboard {
  padding-top: 1rem;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages.vue